"use client";

import { cn } from "@/lib/utils";
import { useState, useRef, useEffect, ComponentProps } from "react";

interface ImageProps extends ComponentProps<"img"> {
  rootMargin?: string;
}

export default function LazyImage({
  src,
  alt,
  className,
  rootMargin = "50px",
}: ImageProps) {
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, [rootMargin]);

  const handleError = () => {};

  return (
    <img
      ref={imgRef}
      src={isInView ? src : undefined}
      alt={alt}
      onError={handleError}
      className={cn("transition-opacity duration-300", className)}
    />
  );
}
